import {defaultApi} from "@/config/httpClient";
import {getLanguageHeaders} from "@/config/i18n";
import {
  CounselingCenterDetailsDto,
  CounselingCenterDto,
  CreateCounselingCenterDto,
  FacetResultCounselingCenterSearchResultDto,
  ObjectStatus,
  RegionType,
  CounselingSystemType
} from "@/generated/openapi";
import {OnbTableSortOptions} from "@/models/OnbTableColumnDefinition";
import {asSortString} from "@/utils/apiUtils";
import {AxiosRequestConfig} from "axios";

class CounselingCenterService {

  public getCounselingCenters(area?: string, term?:string, legalEntityId?:string, lookupValueIds?:string, facetTypes?:string, status?: ObjectStatus, updatedAtFrom?: string, updatedAtTo?: string, locationFulltext?: string, withOnlineCounseling?: boolean, withChatCounseling?: boolean, withVideoCounseling?: boolean, withMailCounseling?: boolean, mailCounselingSystem?: CounselingSystemType, videoCounselingSystem?: CounselingSystemType, chatCounselingSystem?: CounselingSystemType, withInternalCounseling?: boolean,limit?:number, offset?:number, sort?:string, options:AxiosRequestConfig<any> = getLanguageHeaders(), long?:number, lat?:number, radius?:number, region?:RegionType): Promise<FacetResultCounselingCenterSearchResultDto> {
    return defaultApi.findCounselingCenters(term, legalEntityId, lookupValueIds, long, lat, radius, facetTypes, region, area, status, updatedAtFrom, updatedAtTo, locationFulltext, withOnlineCounseling, withChatCounseling, withVideoCounseling, withMailCounseling, mailCounselingSystem, videoCounselingSystem, chatCounselingSystem,withInternalCounseling,limit, offset, sort, options).then(response => {
      if(response.data){
        return response.data
      }else{
        return {}
      }

    })
  }

/**
   * Suchmethode für die Verwaltungsapplikation
   * @param area
   * @param term
   * @param legalEntityId
   * @param region
   * @param status
   * @param limit
   * @param offset
   * @param sort
   * @returns
   */
  public findCounselingCentersByAdmin(area?: string, term?:string, legalEntityId?: string, region?: RegionType, status?: ObjectStatus, updatedAtFrom?: string, updatedAtTo?: string, locationFulltext?: string, withChatCounseling?: boolean, withVideoCounseling?: boolean, withMailCounseling?: boolean, mailCounselingSystem?: CounselingSystemType, videoCounselingSystem?: CounselingSystemType, chatCounselingSystem?: CounselingSystemType, withInternalCounseling?:boolean ,limit?: number, offset?: number, sort?: OnbTableSortOptions): Promise<FacetResultCounselingCenterSearchResultDto> {
    const sortString = asSortString(sort)
    return defaultApi.findCounselingCentersByAdmin(term, legalEntityId, undefined, undefined, undefined, undefined, undefined, region, area, status, updatedAtFrom, updatedAtTo, locationFulltext, undefined, withChatCounseling, withVideoCounseling, withMailCounseling, mailCounselingSystem, videoCounselingSystem, chatCounselingSystem, withInternalCounseling, limit, offset, sortString, getLanguageHeaders()).then(response => {
      if(response.data){
        return response.data
      }else{
        return {}
      }
    });
  }

  public createCounselingCenter(legEnt: CreateCounselingCenterDto): Promise<CounselingCenterDto> {
    return defaultApi.createCounselingCenterByAdmin(legEnt).then(resp => {
      return resp.data
    }).catch(err => {
      throw err;
    })
  }

  public updateCounselingCenter(legEnt: CounselingCenterDto): Promise<CounselingCenterDto> {
    return defaultApi.updateCounselingCenterByAdmin(`${legEnt.id}`, legEnt).then(resp => {
      return resp.data
    }).catch(err => {
      throw err;
    })
  }

  public getCounselingCenter(id: string): Promise<CounselingCenterDetailsDto>{
    return defaultApi.getCounselingCenter(id, getLanguageHeaders()).then((resp) => {
          return resp.data
        })
  }

  public getCounselingCenterByAdmin(id: string): Promise<CounselingCenterDto>{
    return defaultApi.getCounselingCenterByAdmin(id).then((resp) => {
          return resp.data
        })
  }

  public deleteCounselingCenter(id: string): Promise<void> {
    return defaultApi.deleteCounselingCenterByAdmin(id).then((_) => {
      return
    })
  }
}


const counselingCenterService = new CounselingCenterService()
export default counselingCenterService
